
import CommunityDetailsPage from '~/components/page-components/communitypage/CommunityDetailsPage.vue';
import communityinfo from '~/helpers/communityinfo';

export default {
  components: { CommunityDetailsPage },
  data () {
    return {
      p: communityinfo[2]
    };
  }
};
